import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Flag } from "lucide-react";

export default function AdminChatPage() {
  const [sessions, setSessions] = useState([]);
  const [active, setActive] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    api.get("/admin/chat/sessions").then((r) => setSessions(r.data));
  }, []);

  useEffect(() => {
    if (active) api.get(`/admin/chat/sessions/${active}`).then((r) => setDetail(r.data));
  }, [active]);

  return (
    <div className="p-6 md:p-8 h-[calc(100vh-0px)]" data-testid="admin-chat">
      <h1 className="font-display text-2xl font-bold text-[#0A1628] mb-6">Chat sessions</h1>
      <div className="grid lg:grid-cols-3 gap-4 h-[calc(100vh-180px)]">
        <div className="bg-white border border-[#E5E7EB] rounded-2xl soft-shadow overflow-y-auto">
          <ul className="divide-y divide-[#F3F4F6]">
            {sessions.map((s) => (
              <li key={s.id}>
                <button
                  onClick={() => setActive(s.id)}
                  data-testid={`chat-session-${s.id.slice(0, 8)}`}
                  className={`w-full text-left px-4 py-3 hover:bg-[#F9FAFB] ${active === s.id ? "bg-[#F9FAFB]" : ""}`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-mono-display text-xs text-[#0A1628]">{s.id.slice(0, 12)}</span>
                    {s.escalated && (
                      <span className="inline-flex items-center gap-1 text-[10px] text-red-600 font-semibold">
                        <Flag className="w-3 h-3" /> Escalated
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-[#4B5563] mt-1 line-clamp-2">{s.last_message}</div>
                  <div className="text-[10px] text-[#9CA3AF] mt-1 font-mono-display">
                    {new Date(s.updated_at).toLocaleString()}
                  </div>
                </button>
              </li>
            ))}
            {sessions.length === 0 && <li className="p-10 text-center text-[#9CA3AF] text-sm">No sessions.</li>}
          </ul>
        </div>
        <div className="lg:col-span-2 bg-white border border-[#E5E7EB] rounded-2xl soft-shadow overflow-y-auto">
          {!detail ? (
            <div className="p-10 text-center text-[#9CA3AF] text-sm">Select a session to view transcript.</div>
          ) : (
            <div className="p-5 space-y-3">
              {detail.messages.map((m) => (
                <div key={m.id} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
                  <div
                    className={`max-w-[75%] rounded-2xl px-4 py-2.5 text-sm whitespace-pre-wrap ${
                      m.role === "user"
                        ? "bg-[#0A1628] text-white rounded-br-sm"
                        : "bg-[#F9FAFB] border border-[#E5E7EB] text-[#0A1628] rounded-bl-sm"
                    }`}
                  >
                    {m.text}
                    {m.escalate && <div className="text-[10px] text-red-500 mt-1 font-semibold">⚑ Escalated</div>}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
